export default "__VITE_ASSET__CzcrC40u__"